import React, { useEffect } from 'react';

const useScreenSize = () => {
  const [size, setSize] = React.useState(0);
  useEffect(() => {
    const handleResize = () => {
      setSize(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return { size: size };
};

export default useScreenSize;
